import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CommandPalette({
  open,
  onClose,
  menus = [],
  addQuickItem,
}) {
  const [q, setQ] = useState("");
  const ref = useRef(null);
  const navigate = useNavigate();

  const index = useMemo(() => {
    const arr = [];
    for (const m of menus) {
      for (const it of m.items) {
        const item = typeof it === "string" ? { label: it } : it;
        arr.push({
          label: `${m.label} → ${item.label}`,
          to: item.to || null,
          value: `${m.id}:${item.label}`,
        });
      }
    }
    return arr;
  }, [menus]);

  const filtered = index.filter((i) =>
    i.label.toLowerCase().includes(q.toLowerCase())
  );

  useEffect(() => {
    const onKey = (e) => {
      const mod = e.ctrlKey || e.metaKey;
      if (mod && e.key.toLowerCase() === "k") {
        e.preventDefault();
        if (open) onClose();
        else ref.current?.showModal?.();
      }
      if (e.key === "Escape" && open) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>Command Palette</h3>
        <input
          className="kbar-input"
          placeholder="Type to search (e.g., USER LIST)…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          autoFocus
        />
        <div className="kbar-list">
          {filtered.map((it, i) => (
            <div
              className="kbar-item"
              key={i}
              onClick={() => {
                if (it.to) navigate(it.to);
                onClose();
              }}
            >
              {it.label}
              <button
                style={{ float: "right" }}
                onClick={(e) => {
                  e.stopPropagation();
                  addQuickItem(it.value);
                }}
                title="Pin to quick bar"
              >
                Pin
              </button>
            </div>
          ))}
          {filtered.length === 0 && <div className="kbar-item">No results</div>}
        </div>
        <div style={{ textAlign: "right", marginTop: 8 }}>
          <button className="action-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
